// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --green1: #088a46;
  --green2: #48b95e;
  --green3: #aad357;
  --red1: #c01e2e;
  --red2: #ec1941;
  --red3: #f15257;
  --orange1: #f78234;
  --orange2: #f6a125;
  --orange3: #fdb132;
  --darkblue1: #00263c;
  --darkblue2: #063e67;
  --blue1: #2a579c;
  --blue2: #0181c9;
  --blue3: #00aef3;
  --white: #ffffff;
  --grey1: #e1e1e1;
  --grey2: #cccccc;
  --grey3: #888888;
  --black: #000000;

  --shell-bg-color: var(--blue1);
  --shell-color: var(--white);
  --header-bg-color: var(--blue1);
  --header-color: var(--white);
  --menu-bg-color: var(--darkblue1);
  --menu-color: var(--white);
  --menu-color-active: var(--white);

  --border-dark-color: var(--darkblue1);
  --btn-bg-color: var(--darkblue2);
  --border-dark-bg-color: var(--darkblue1);
  --btn-dark-bg-color: var(--darkblue1);

  --theme-dark-color: var(--blue1);
  --theme-color: var(--blue2);
  --theme-light-color: var(--blue3);

  --tracking-bg-color: var(--blue3);
  --tracking-border: var(--darkblue1);
  --tracking-btn-color: var(--green3);
  --tracking-btn-border-color: var(--green1);

  --shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
`, "",{"version":3,"sources":["webpack://./core/components/shared.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;;EAEjC,qCAAqC;EACrC,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;;EAErC,gCAAgC;EAChC,2BAA2B;EAC3B,iCAAiC;;EAEjC,iCAAiC;EACjC,mCAAmC;EACnC,mCAAmC;EACnC,0CAA0C;;EAE1C,gEAAgE;AAClE","sourcesContent":[":root {\r\n  --green1: #088a46;\r\n  --green2: #48b95e;\r\n  --green3: #aad357;\r\n  --red1: #c01e2e;\r\n  --red2: #ec1941;\r\n  --red3: #f15257;\r\n  --orange1: #f78234;\r\n  --orange2: #f6a125;\r\n  --orange3: #fdb132;\r\n  --darkblue1: #00263c;\r\n  --darkblue2: #063e67;\r\n  --blue1: #2a579c;\r\n  --blue2: #0181c9;\r\n  --blue3: #00aef3;\r\n  --white: #ffffff;\r\n  --grey1: #e1e1e1;\r\n  --grey2: #cccccc;\r\n  --grey3: #888888;\r\n  --black: #000000;\r\n\r\n  --shell-bg-color: var(--blue1);\r\n  --shell-color: var(--white);\r\n  --header-bg-color: var(--blue1);\r\n  --header-color: var(--white);\r\n  --menu-bg-color: var(--darkblue1);\r\n  --menu-color: var(--white);\r\n  --menu-color-active: var(--white);\r\n\r\n  --border-dark-color: var(--darkblue1);\r\n  --btn-bg-color: var(--darkblue2);\r\n  --border-dark-bg-color: var(--darkblue1);\r\n  --btn-dark-bg-color: var(--darkblue1);\r\n\r\n  --theme-dark-color: var(--blue1);\r\n  --theme-color: var(--blue2);\r\n  --theme-light-color: var(--blue3);\r\n\r\n  --tracking-bg-color: var(--blue3);\r\n  --tracking-border: var(--darkblue1);\r\n  --tracking-btn-color: var(--green3);\r\n  --tracking-btn-border-color: var(--green1);\r\n\r\n  --shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
